import en from './en.js'
import ko from './ko.js'
import jp from './jp.js'
// import VueCookies from 'vue-cookies'

const supported = ['en', 'ko', 'jp']
let locale = 'ko'

try {
  // const cookieLocale = VueCookies.get('locale')
  const sessionLocale = localStorage.getItem('locale') ; 

  if (sessionLocale) locale = sessionLocale
  else {
    // get browser default language
    const { 0: browserLang } = navigator.language.split('-')

    if (supported.includes(browserLang)) locale = browserLang ;    
  }
} catch (e) {
  console.log(e)
}

export default {
  // current locale
  locale,

  // when translation is not available fallback to that locale
  fallbackLocale: 'ko',

  // availabled locales for user selection
  availableLocales: [
    {
      code: 'en',
      flag: 'us',
      label: 'ENGLISH',
      messages: en
    },
    {
      code: 'ko',
      flag: 'kr',
      label: '한국어',
      messages: ko
    },
    {
      code: 'jp',
      flag: 'jp',
      label: '日本語',
      messages: jp
    }
  ]
}
